import CustomReportTemplateIcon from "../../../components/SVGComponents/CustomReportTemplateIcon";
import { ControlAndSettingsIcon } from "../../../components/SVGComponents/ControlAndSettingsIcon";
import { CXR_SUBTABS_ID, PEER_REVIEW_SUBTABS_ID, USERTYPES, ARCHIVED_ACCESS_SUBTABS_ID, SAVED_SUBTABS_ID } from "../../../constants/Constants";
import UnreportedIcon from "../../../components/SVGComponents/StudyList/Tabs/UnreportedIcon";
import SavedIcon from "../../../components/SVGComponents/StudyList/Tabs/SavedIcon";
import ReportedIcon from "../../../components/SVGComponents/StudyList/Tabs/ReportedIcon";
import ClosedIcon from "../../../components/SVGComponents/StudyList/Tabs/ClosedIcon";
import QCReviewIcon from "../../../components/SVGComponents/StudyList/Tabs/QCReviewIcon";
import QCFixIcon from "../../../components/SVGComponents/StudyList/Tabs/QCFixIcon";
import QCVerifyIcon from "../../../components/SVGComponents/StudyList/Tabs/QCVerifyIcon";
import ReturnedIcon from "../../../components/SVGComponents/StudyList/Tabs/ReturnedIcon";
import CriticalIcon from "../../../components/SVGComponents/StudyList/Tabs/CriticalIcon";
import LibraryIcon from "../../../components/SVGComponents/StudyList/Tabs/LibraryIcon";
import { getActiveTabId } from "./helpingFunctions";
import { isMobile } from "react-device-detect";
import PeerReviewIcon from "../../../components/SVGComponents/StudyList/Tabs/PeerReviewIcon";
export const initPaginationData = {
  unreported: {
    pageIndex:0,
    pageSize: 50,
  },
  saved: {
    pageIndex:0,
    pageSize: 50,
  },
  reviewPending: {
    pageIndex:0,
    pageSize: 50,
  },
  reported: {
    pageIndex:0,
    pageSize: 50,
  },
  closed: {
    pageIndex:0,
    pageSize: 50,
  },
  qcreview: {
    pageIndex:0,
    pageSize: 50,
  },
  qcfix: {
    pageIndex:0,
    pageSize: 50,
  },
  qcverify: {
    pageIndex:0,
    pageSize: 50,
  },
  returned: {
    pageIndex:0,
    pageSize: 50,
  },
  critical: {
    pageIndex:0,
    pageSize: 50,
  },
  library: {
    pageIndex: 0,
    pageSize: 50
  },
  normal: {
    pageIndex:0,
    pageSize: 50,
  },
  normalwithfb: {
    pageIndex:0,
    pageSize: 50,
  },
  abnormal: {
    pageIndex:0,
    pageSize: 50,
  },
  reviewAssigned: {
    pageIndex: 0,
    pageSize: 50
  },
  reviewComplete: {
    pageIndex:0,
    pageSize: 50,
  },
  evaluationAssigned: {
    pageIndex:0,
    pageSize: 50,
  },
  evaluationComplete: {
    pageIndex:0,
    pageSize: 50,
  },
  pending: {
    pageIndex:0,
    pageSize: 50,
  },  
  approved: {
    pageIndex:0,
    pageSize: 50,
  },
  rejected: {
    pageIndex:0,
    pageSize: 50,
  },
}


export const initPaginationObjData = {
  unreported: {
    pageIndex: 0,
    pageSize: 50,
  },
  saved: {
    pageIndex: 0,
    pageSize: 50,
  },
  reported: {
    pageIndex: 0,
    pageSize: 50,
  },
  closed: {
    pageIndex: 0,
    pageSize: 50,
  },
  qcreview: {
    pageIndex: 0,
    pageSize: 50,
  },
  qcfix: {
    pageIndex: 0,
    pageSize: 50,
  },
  qcverify: {
    pageIndex: 0,
    pageSize: 50,
  },
  returned: {
    pageIndex: 0,
    pageSize: 50,
  },
  critical: {
    pageIndex: 0,
    pageSize: 50,
  },
  normal: {
    pageIndex: 0,
    pageSize: 50,
  },
  normalwithfb: {
    pageIndex: 0,
    pageSize: 50,
  },
  abnormal: {
    pageIndex: 0,
    pageSize: 50,
  },

}

export const tabDetails = (roles,selectedValue,themeName, unreportedAllTabs, peerReviewAssignedTab, contextSwitchUser, qcReviewer, peerReviewAdmin, peerReviewEvaluator, archivedStudyRequestTab, savedAllTabs) => {
  if(contextSwitchUser == undefined || contextSwitchUser == null){
      contextSwitchUser = false;
    }
    let isVdcPlatform = (process.env.REACT_APP_VDC_PLATFORM=="true"||process.env.REACT_APP_VDC_PLATFORM==true)?true:false;
    let isBvpPlatform = (process.env.REACT_APP_BVP_PLATFORM == "true" || process.env.REACT_APP_BVP_PLATFORM == true) ? true : false;

    console.log("---- Roles ------  ",unreportedAllTabs, peerReviewAssignedTab, selectedValue);
    let isFirmAdmin = roles[0]==USERTYPES.FIRMADMIN?true:false;
    let isAdmin = roles[0]==USERTYPES.ADMIN?true:false;
    let isRadiologist = roles[0]==USERTYPES.RADIOLOGIST?true:false;
    let isFirmTechnician = roles[0]==USERTYPES.FIRMTECHNICIAN?true:false;
    let isFirmDoctor = roles[0]==USERTYPES.FIRMDOCTOR?true:false;
    let isSupervisor = roles[0]==USERTYPES.SUPERVISOR?true:false;
    let isTypist = roles[0] == USERTYPES.TYPIST ? true: false;
    if(qcReviewer == null || qcReviewer == undefined){
      qcReviewer = true;
    }else{
      qcReviewer = qcReviewer == 1 ? true:false
    }
    
    if(themeName!="dark" && themeName != "dark-midnight" && themeName != "blue-theme"){
      //selectedValue = 'none';
    } 
    return [
    {
      id: unreportedAllTabs.data.tabId,
      title: isTypist ? "Unsaved" : "Unreported",
      tabNameId: unreportedAllTabs.data.id,
      contentClass: "tab-content-study-list",
      icon: <UnreportedIcon active={CXR_SUBTABS_ID.includes(selectedValue) || selectedValue == "study_1" ? true : false} />,
      show: isFirmAdmin || isAdmin || isRadiologist || isFirmTechnician || isFirmDoctor || isSupervisor || isTypist
    },
    !isBvpPlatform ? {
      id: "study_2",
      title: "Saved",
      tabNameId: "saved",
      contentClass: "tab-content-study-list",
      icon: <SavedIcon active={selectedValue == "study_2"} />,
      show:  isFirmAdmin || isAdmin || isRadiologist || isFirmTechnician || isFirmDoctor || isSupervisor || isTypist
    } : {
      id: savedAllTabs.data.tabId,
      title: "Saved",
      tabNameId: savedAllTabs.data.id,
      contentClass: "tab-content-study-list",
      icon: <SavedIcon active={SAVED_SUBTABS_ID.includes(selectedValue) || selectedValue == "study_2" ? true : false} />,
      show: isFirmAdmin || isAdmin || isRadiologist || isFirmTechnician || isFirmDoctor || isSupervisor || isTypist
    },
    {
      id: "study_3",
      title: "Reported",
      tabNameId: "reported",
      contentClass: "tab-content-study-list",
      icon: <ReportedIcon active={selectedValue == "study_3"} />,
      show:  isFirmAdmin || isAdmin || isRadiologist || isFirmTechnician || isFirmDoctor || isSupervisor
    },
    {
      id: "study_4",
      title: "Closed",
      tabNameId: "closed",
      contentClass: "tab-content-study-list",
      icon: <ClosedIcon active={selectedValue == "study_4"} />,
      show:  isFirmAdmin || isAdmin || isSupervisor || isFirmTechnician || isFirmDoctor
    },
    {
      id: "study_5",
      title: "QC Review",
      tabNameId: "qcreview",
      contentClass: "tab-content-study-list",
      icon: <QCReviewIcon active={selectedValue == "study_5"} />,
      show: !contextSwitchUser &&( isFirmAdmin || (isSupervisor && qcReviewer)) && !isVdcPlatform
    },
    {
      id: "study_6",
      title: "QC Fix",
      tabNameId: "qcfix",
      contentClass: "tab-content-study-list",
      icon: <QCFixIcon active={selectedValue == "study_6"} />,
      show: !contextSwitchUser &&(  isFirmAdmin || isRadiologist || (isSupervisor && qcReviewer)) && !isVdcPlatform
    },
    {
      id: "study_7",
      title: "QC Verify",
      tabNameId: "qcverify",
      contentClass: "tab-content-study-list",
      icon: <QCVerifyIcon active={selectedValue == "study_7"} />,
      show: !contextSwitchUser &&(  isFirmAdmin || (isSupervisor && qcReviewer)) && !isVdcPlatform
    },
    {
      id: "study_8",
      title: "Returned",
      tabNameId: "returned",
      contentClass: "tab-content-study-list",
      icon: <ReturnedIcon active={selectedValue == "study_8"} />,
      show: !contextSwitchUser &&(  isFirmAdmin || isAdmin || isSupervisor)
    },
    {
      id: "study_9",
      title: "Critical",
      tabNameId: "critical",
      contentClass: "tab-content-study-list",
      icon: <CriticalIcon active={selectedValue == "study_9"} />,
      show: !contextSwitchUser &&(  isFirmAdmin || isAdmin || isRadiologist || isSupervisor)
    },
    {
      id: "study_10",
      title: "Library",
      tabNameId: "library",
      contentClass: "tab-content-study-list",
      icon: <LibraryIcon active={selectedValue == "study_10"} />,
      show: !contextSwitchUser &&(  isRadiologist)
    },
    {
      id: peerReviewAssignedTab.data.tabId,
      title: "Peer Review",
      tabNameId: peerReviewAssignedTab.data.id,
      contentClass: "tab-content-study-list",
      icon: <PeerReviewIcon active={PEER_REVIEW_SUBTABS_ID.includes(selectedValue) || selectedValue == "study_14" ? true : false}  />,
      show: !contextSwitchUser && isVdcPlatform && ( ((isFirmAdmin || isSupervisor) && (peerReviewAdmin || peerReviewEvaluator)) || isRadiologist)
    },
    {
      id: archivedStudyRequestTab.data.tabId,
      title: "Access request",
      tabNameId: archivedStudyRequestTab.data.id,
      contentClass: "tab-content-study-list",
      icon: <LibraryIcon active={ARCHIVED_ACCESS_SUBTABS_ID.includes(selectedValue) || selectedValue == "study_18" ? true : false}  />,
      show: !contextSwitchUser && isVdcPlatform && (isFirmAdmin)
    },
    // {
    //   id: "study_11",
    //   title: "Unreported",
    //   contentClass: "tab-content-study-list",
    //   icon: <UnreportedIcon active={selectedValue == "study_1"} />,
    //   show: isFirmAdmin || isAdmin || isRadiologist || isFirmTechnician || isFirmDoctor || isSupervisor
    // },
    // {
    //   id: "study_12",
    //   title: "Unreported",
    //   contentClass: "tab-content-study-list",
    //   icon: <UnreportedIcon active={selectedValue == "study_1"} />,
    //   show: isFirmAdmin || isAdmin || isRadiologist || isFirmTechnician || isFirmDoctor || isSupervisor
    // },
    // {
    //   id: "study_13",
    //   title: "Unreported",
    //   contentClass: "tab-content-study-list",
    //   icon: <UnreportedIcon active={selectedValue == "study_1"} />,
    //   show: isFirmAdmin || isAdmin || isRadiologist || isFirmTechnician || isFirmDoctor || isSupervisor
    // }
]};

export const mainStackStyle = {
    justifyContent: "space-evenly",
    alignItems: "center",
  };

export const checkBoxStyle = {
    root: {
      paddingLeft: "5px",
    },
    checkbox: {
      borderColor: "#8A8886",
      width: "16px",
      height: "16px",
    },
  };

 export const dropdownStyles = {
    dropdown: { width: 210, broderRadius: 0 },
    dropdownItemsWrapper :{
      maxHeight:'400px'
  },
    title: {
      //border: "1px solid rgba(200, 198, 196, 0.3)",
      borderRadius: "7px",
      background: "none",
      height: "32px",
      display: "flex",
      alignItem: "center",
    },
    dropdownItems: {
      selectors: {
        "@media(min-width: 640px)": {
          maxHeight: 300,
        },
      },
    },
  };

  export const assignmentDropdownStyles = {
    dropdown: { width: 180, background: "transparent", broderRadius: "7px" },
    title: {
      border: "1px solid rgba(200, 198, 196, 0.3)",
      borderRadius: "7px",
      background: "none",
      height: "30px",
      display: "flex",
      alignItem: "center",
    },
    dropdownItems: {
      selectors: {
        "@media(min-width: 640px)": {
          maxHeight: 300,
        },
      },
    },
  };
  

  export const reAssignButtonStyle = {
    root: {
      fontSize: "12px",
      fontWeight: "400",
      padding: "0px 5px",
      height: "24px",
      width:"60px",
      minWidth:"60px",
      marginLeft:"16px",
    }
  };

  export const reAssignButtonFirmStyle = {
    root: {
      padding: "0px 5px",
      height: "24px",
      // width:"50px",
      // minWidth:"50px",
      marginLeft:"10px",
      borderRadius:'7px'
      // marginTop:"6px",
    },
    label:{
      fontSize: "12px",
      fontWeight: "400",
    }
  };

  export const assignButtonStyle = {
    root: {
      padding: "0px 5px",
      height: "24px",
      width:"60px",
      minWidth:"60px",
      marginLeft:"13px",
      borderRadius:'7px'
    },
    label:{
      fontSize: "12px",
      fontWeight: "400",
    }
  };

  export const superAdminAssignButtonStyle = {
    root: {
      
      padding: "0px 10px",
      height: "24px",
      width:"60px",
      minWidth:"60px",
      marginLeft:"22px",
      borderRadius:'7px'
    },
    label:{
      fontSize: "12px",
      fontWeight: "400",
    }
  };

  export const superAdminAssignButtonPopupStyle = {
    root: {
      padding: "0px 10px",
      height: "24px",
      width:"60px",
      minWidth:"60px",
      marginLeft:"28px",
      borderRadius:'7px'
    },
    label:{
      fontSize: "12px",
      fontWeight: "400",
    }
  };

  export const superAdminReAssignButtonStyle = {
    root: {
      padding: "0px 10px",
      height: "24px",
      width:"60px",
      minWidth:"60px",
      marginLeft:"13px",
      borderRadius:'7px'
    },
    label:{
      fontSize: "12px",
      fontWeight: "400",
    }
  };

  export const hideButtonStyle = {
    root: {
      visibility: "hidden",
      padding: "0px 5px",
      height: "24px",
      width:"60px",
      minWidth:"60px",
      marginLeft:"13px",
      borderRadius:'7px'
    },
    label:{
      fontSize: "12px",
      fontWeight: "400",
    }
  }

  export const superAdminReAssignPopUpButtonStyle = {
    root: {
      padding: "0px 0px",
      height: "24px",
      width:"50px",
      minWidth:"50px",
      marginLeft:"33px",
      borderRadius:'7px'
    },
    label:{
      fontSize: "10px",
      fontWeight: "400",
    }
  };

export const radiologistNameStack = {
    fontSize: "14px",
    fontWeight: "400",
    alignItems: "center",
    marginTop: "1px",
  };

export const radiologistStackAssigned = {
    fontSize: "14px",
    fontWeight: "400",
    alignItems: "center",
    marginTop: "4px",
  };

export const hospitalStackStyles = {
  fontSize: "14px",
  fontWeight: "400",
  alignItems: "flex-start",
  display:'flex',
  flexDirection:'column',
  marginTop: "2px",
  marginBottom:'5px'
};